import { AnonymousLanguageService } from './globalservices/anonymous-language-service';
import {EvoContainer} from './globalservices/ldc/evo-container';
import { LoginService } from './globalservices/login.service';

(() => {
    const loginGlobalServices = {} as any;
    loginGlobalServices['AnonymousLanguageService'] = new AnonymousLanguageService();
    loginGlobalServices['LoginService'] = new LoginService();
    loginGlobalServices['EvoContainer'] = new EvoContainer();

    (window as any).globalServices = loginGlobalServices;
})();
